export default __webpack_public_path__ + "static/media/beit-kneset-mission.d255559d.png";